import { gql } from '@apollo/client';
import { Link } from 'components/Link';
import { Panel } from 'components/Panel';
import { Text } from 'components/Text';
import { useTranslation } from 'components/translation/TranslationProvider';
import { formatFieldValue } from 'helpers/Field';
import { React, useQuery } from 'libs/react';
import './OrderVoucherFieldsPanel.scss';
/**
 * Vouchers of the order with the answers to their VOUCHER fields
 * @const OrderVoucherFieldsQuery
 * @since 1.0.0
 */
const OrderVoucherFieldsQuery = gql `
  query OrderVoucherFields($input: VouchersInput) {
    vouchers(input: $input) {
      items {
        id
        code
        saleItem {
          id
          title
        }
        fieldValues {
          id
          value
          field {
            id
            title
            type
            options
          }
        }
      }
    }
  }
`;
/**
 * The answers given in the store for each voucher (participant name…).
 * Shown only when one voucher has answers; edited on the voucher page.
 *
 * @component OrderVoucherFieldsPanel
 * @since 1.0.0
 */
export function OrderVoucherFieldsPanel(props) {
    var _a, _b;
    const { orderId } = props;
    const { language } = useTranslation();
    const [data] = useQuery(OrderVoucherFieldsQuery, {
        variables: {
            input: {
                query: [{ field: 'order', value: orderId }],
                limit: 500
            }
        },
        fetchPolicy: 'cache-and-network'
    });
    const vouchers = ((_b = (_a = data === null || data === void 0 ? void 0 : data.vouchers) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).filter((voucher) => { var _a, _b; return ((_b = (_a = voucher.fieldValues) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; });
    if (vouchers.length === 0) {
        return null;
    }
    return (React.createElement(Panel, { title: t('Information per voucher'), collapsible: false },
        React.createElement("div", { className: "order-voucher-fields-panel" }, vouchers.map((voucher) => {
            var _a, _b, _c;
            return (React.createElement("div", { key: voucher.id, className: "order-voucher-fields-panel__voucher" },
                React.createElement("div", { className: "order-voucher-fields-panel__header" },
                    React.createElement(Link, { className: "order-voucher-fields-panel__code", route: { name: 'voucher.update', data: { id: voucher.id } } }, voucher.code),
                    React.createElement(Text, { className: "order-voucher-fields-panel__product", value: (_b = (_a = voucher.saleItem) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '' })), (_c = voucher.fieldValues) === null || _c === void 0 ? void 0 :
                _c.map((fieldValue) => {
                    var _a;
                    return (React.createElement("div", { key: fieldValue.id, className: "order-voucher-fields-panel__field" },
                        React.createElement("span", { className: "order-voucher-fields-panel__label" }, fieldValue.field.title),
                        React.createElement(Text, { className: "order-voucher-fields-panel__value", value: String((_a = formatFieldValue(fieldValue.value, fieldValue.field.type, fieldValue.field, language)) !== null && _a !== void 0 ? _a : ''), html: true })));
                })));
        }))));
}
